import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "./authenticationSlice";
import deviceReducer from "./deviceSlice";
import notificationReducer from "./notificationSlice";
import themeReducer from "./themeSlice";
import collapseReducer from "./collapseSlice";

const store = configureStore({
  reducer: {
    authenticationValues: authenticationReducer,
    deviceValues: deviceReducer,
    notificationValues: notificationReducer,
    themeValues: themeReducer,
    collapseValues: collapseReducer,
  },
});

export default store;
